import { render } from "./liveItem.vue?vue&type=template&id=bd1142aa&scoped=true"
import script from "./liveItem.vue?vue&type=script&lang=js"
export * from "./liveItem.vue?vue&type=script&lang=js"

import "./liveItem.vue?vue&type=style&index=0&id=bd1142aa&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1142aa"]])

export default __exports__